import { render, staticRenderFns } from "./docShow.vue?vue&type=template&id=61efd9a4&"
import script from "./docShow.vue?vue&type=script&lang=js&"
export * from "./docShow.vue?vue&type=script&lang=js&"
import style0 from "./docShow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports